// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dy1SL","newExpiryDate":"styles_newExpiryDate__ItzZ-","footer":"styles_footer__Hwq9C"};